import { render, staticRenderFns } from "./SubcategoryTiles.vue?vue&type=template&id=63230f34&"
import script from "./SubcategoryTiles.vue?vue&type=script&lang=js&"
export * from "./SubcategoryTiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports